import React from 'react';

const TERMS = `ANTES DE FIRMAR ASEGÚRESE QUE SI TUQUE O CAJAS ESTÉN DEBIDAMENTE SELLADA LUEGO NO HABRÁ RECLAMO ALGUNO. NO SOMOS RESPONSABLES POR DAÑOS A ARTÍCULOS FRÁGILES, ALIMENTOS, PLANTAS Y PERTENENCIAS PERSONALES. LA DEMANDA DE CUALQUIER TIPO O RECLAMO POR PÉRDIDA O DAÑOS ESTÁN SUJETO AL MONTO DEL SEGURO QUE FUERON ASEGURADOS. EN NINGÚN CASO EL MONTO DEL RECLAMO EXCEDERÁ EL PRECIO PAGADO POR EL ENVÍO. SE APLICARÁ UN CARGO ADICIONAL DE $5.00 POR CADA ARTÍCULO QUE NO SEA ENVOLTURA SELLADA. LAS FACTURAS QUE SUS PAGOS ESTÁN EN EFECTIVO (Y NO SE HAN SIDO CONFIRMADOS Y NO SE HAN SIDO CONFIRMADOS) AL MOMENTO DE ENTREGA, SE LES APLICARÁ UN 10% ADICIONAL AL PRECIO POR CONCEPTO DE ALMACENAJE.`;

function PrintFactura({ factura, onClose }) {
  const total = factura.detalles?.reduce((s, d) => s + d.total, 0) || 0;
  const pagado = (factura.pagos?.reduce((s, p) => s + p.monto, 0) || 0) + (factura.deposito || 0);
  const balance = total - pagado;
  const totalBultos = factura.detalles?.reduce((s, d) =>
    s + (parseInt(d.cajas) || 0) + (parseInt(d.fornitura) || 0) +
    (parseInt(d.tanques) || 0) + (parseInt(d.vehiculo) || 0), 0) || 0;

  const fmt = (monto) => {
    if (factura.moneda === 'DOP') return `RD$${Number(monto).toLocaleString('es-DO', { minimumFractionDigits: 2 })}`;
    return `$${Number(monto).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  };

  const handlePrint = () => window.print();

  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden; }
          #print-area, #print-area * { visibility: visible; }
          #print-area { position: fixed; left: 0; top: 0; width: 100%; }
          .no-print { display: none !important; }
          @page { size: letter; margin: 0.2in; }
        }
        @media screen {
          #print-area { max-width: 1000px; margin: 20px auto; background: white; padding: 10px; box-shadow: 0 0 10px rgba(0,0,0,0.1); }
        }
      `}</style>

      {/* Botones */}
      <div className="no-print" style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, display: 'flex', gap: 10 }}>
        <button onClick={handlePrint} style={{ padding: '10px 24px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>🖨️ Imprimir</button>
        <button onClick={onClose} style={{ padding: '10px 24px', background: '#64748b', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>✕ Cerrar</button>
      </div>

      <div id="print-area" style={{ fontFamily: 'Arial, sans-serif', fontSize: 15, color: '#000', padding: '18px 24px' }}>

        {/* Header empresa */}
        <div style={{ display: 'flex', alignItems: 'center', borderBottom: '3px solid #000', paddingBottom: 10, marginBottom: 10 }}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ fontSize: 26, fontWeight: 900, letterSpacing: 1 }}>EMBARQUE ORIENTAL, LLC.</div>
            <div style={{ fontSize: 14, fontWeight: 600, margin: '4px 0' }}>LLEVAMOS TODO TIPO DE ENCOMIENDAS A REPÚBLICA DOMINICANA</div>
            <div style={{ fontSize: 13 }}>Oficina Deltona FL: (386) 281-3237 · (386) 320-2613 · Oficina RD: (829) 639-4341</div>
          </div>
        </div>

        {/* Furgón / Fecha */}
        <div style={{ display: 'flex', gap: 20, marginBottom: 10, border: '1.5px solid #000', padding: '8px 12px', fontSize: 14 }}>
          <div><strong>FURGÓN No:</strong> {factura.furgonNumero}</div>
          <div style={{ marginLeft: 'auto' }}><strong>DATE:</strong> {new Date(factura.fecha).toLocaleDateString('es-DO')}</div>
          <div><strong>FACTURA:</strong> {factura.numero}</div>
        </div>

        {/* Remitente / Destinatario */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          {[
            { title: 'ENVÍA', nombre: factura.remNombre, direccion: factura.remDireccion, ciudad: factura.remCiudad, telefono: factura.remTelefono },
            { title: 'RECIBE', nombre: factura.desNombre, direccion: factura.desDireccion, ciudad: factura.desCiudad, telefono: factura.desTelefono },
          ].map(({ title, nombre, direccion, ciudad, telefono }) => (
            <div key={title} style={{ border: '1.5px solid #000', padding: '6px 10px' }}>
              <div style={{ fontWeight: 700, fontSize: 15, borderBottom: '1px solid #ccc', marginBottom: 5, paddingBottom: 3 }}>{title}</div>
              <table style={{ width: '100%', fontSize: 13 }}>
                <tbody>
                  <tr><td style={{ fontWeight: 600, width: 100, verticalAlign: 'top' }}>NOMBRE:</td><td>{nombre}</td></tr>
                  <tr><td style={{ fontWeight: 600, verticalAlign: 'top' }}>DIRECCIÓN:</td><td>{direccion}</td></tr>
                  <tr><td style={{ fontWeight: 600, verticalAlign: 'top' }}>CIUDAD:</td><td>{ciudad}</td></tr>
                  <tr><td style={{ fontWeight: 600, verticalAlign: 'top' }}>TELÉFONO:</td><td>{telefono}</td></tr>
                </tbody>
              </table>
            </div>
          ))}
        </div>

        {/* Tabla artículos */}
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 8, fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f0f0f0' }}>
              {['CAJAS', 'FORNITURA', 'TANQUES', 'VEHÍCULO', 'OTRO', 'DESCRIPCIÓN', 'CAN.', 'PRECIO UNIT.', 'TOTAL'].map(h => (
                <th key={h} style={{ border: '1.5px solid #000', padding: '6px 6px', textAlign: 'center', fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {factura.detalles?.map((d, i) => (
              <tr key={i}>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'center' }}>{d.cajas || ''}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'center' }}>{d.fornitura || ''}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'center' }}>{d.tanques || ''}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'center' }}>{d.vehiculo || ''}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px' }}>{d.otro || ''}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px' }}>{d.descripcion}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'center' }}>{d.cantidad}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'right' }}>{fmt(d.precioUnitario)}</td>
                <td style={{ border: '1px solid #000', padding: '6px 6px', textAlign: 'right', fontWeight: 600 }}>{fmt(d.total)}</td>
              </tr>
            ))}
            {Array.from({ length: Math.max(0, 8 - (factura.detalles?.length || 0)) }).map((_, i) => (
              <tr key={`empty-${i}`}>
                {Array.from({ length: 9 }).map((_, j) => (
                  <td key={j} style={{ border: '1px solid #000', padding: '6px 6px', height: 26 }}></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totales */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <div style={{ border: '1.5px solid #000', padding: '6px 14px', fontSize: 14, alignSelf: 'flex-end' }}>
            <strong>Total de Bultos/Paquetes: {totalBultos}</strong>
          </div>
          <div style={{ border: '1.5px solid #000', padding: '6px 14px', minWidth: 260 }}>
            <table style={{ width: '100%', fontSize: 14 }}>
              <tbody>
                <tr><td style={{ fontWeight: 600, paddingRight: 12 }}>TOTAL:</td><td style={{ textAlign: 'right', fontWeight: 700 }}>{fmt(total)}</td></tr>
                <tr><td style={{ fontWeight: 600 }}>DEPÓSITO:</td><td style={{ textAlign: 'right' }}>{fmt(factura.deposito || 0)}</td></tr>
                <tr style={{ borderTop: '1px solid #000' }}><td style={{ fontWeight: 700 }}>BALANCE:</td><td style={{ textAlign: 'right', fontWeight: 700 }}>{fmt(balance)}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Observaciones */}
        {factura.observaciones && (
          <div style={{ border: '1.5px solid #000', padding: '6px 10px', marginBottom: 8, fontSize: 13 }}>
            <strong>OBSERVACIONES:</strong> {factura.observaciones}
          </div>
        )}

        {/* Términos */}
        <div style={{ border: '1px solid #000', padding: '6px 10px', marginBottom: 10, fontSize: 10, lineHeight: 1.4 }}>
          {TERMS}
        </div>

        {/* Firmas */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 16 }}>
          {['ENTREGADO EN USA POR', 'RECIBIDO EN USA POR', 'RECIBIDO EN RD POR', 'CÉDULA NO.'].map(label => (
            <div key={label} style={{ textAlign: 'center' }}>
              <div style={{ borderTop: '1px solid #000', paddingTop: 5, fontSize: 12, marginTop: 34 }}>{label}</div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default PrintFactura;